import { useCampaigns } from "api/campaigns";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { memo, useState } from "react";
import { CampaignTypes } from "types/campaigns";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
  type?: CampaignTypes;
}

export const CampaignName = memo(({ index, size, onChange, type }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const [campaignSearch, setCampaignSearch] = useState("");
  const { useInfiniteCampaignsList } = useCampaigns();
  const isTimeBasedCampaign = type === CampaignTypes.TIME;
  const isInlineType = size === "inline";
  const {
    data: infiniteCampaignsList,
    size: campaignsSize,
    setSize: setCampaignsSize,
    isValidating,
  } = useInfiniteCampaignsList({
    filters: [
      ...(type
        ? [
            {
              query: "type",
              condition: "eq",
              value: isTimeBasedCampaign ? CampaignTypes.DIRECT : type,
            },
            {
              query: "trigger",
              value: "time",
              condition: isTimeBasedCampaign ? "eq" : "neq",
            },
          ]
        : []),
      ...(campaignSearch
        ? [{ query: "name", condition: "like", value: campaignSearch }]
        : []),
    ],
    sortKey: "name",
    order: "asc",
  });

  const {
    infiniteData: campaignsList,
    anyElementsToFetch: anyCampaignsToFetch,
  } = useManageInfiniteScroll(infiniteCampaignsList || []);

  return (
    <SelectInput
      name={`filters.${index}.value`}
      displaySearch
      items={campaignsList.map((campaign) => ({
        id: campaign.campaignId,
        label: campaign.name,
      }))}
      size={isInlineType ? "small" : size}
      placeholder={message({ id: "value" })}
      asyncSearch={(searchQuery) => setCampaignSearch(searchQuery)}
      data-test-id="filter-value"
      className={isInlineType ? classes.inlineValue : ""}
      adjustWidthToValue={isInlineType}
      anyElementsToFetch={anyCampaignsToFetch}
      loadMoreElements={() =>
        !isValidating && setCampaignsSize(campaignsSize + 1)
      }
      keepDetailedValue
      onChange={onChange}
      validateOnChange
    />
  );
});
